/**
 * @generated SignedSource<<8deea32d3058e757cea3006a2d27ded8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type desktopRecorderApiPauseLocalRecordingMutation$variables = {
  meetingRecordingId: string;
};
export type desktopRecorderApiPauseLocalRecordingMutation$data = {
  readonly confirmClientSideRecordingDidPause: {
    readonly ok: boolean;
  } | null;
};
export type desktopRecorderApiPauseLocalRecordingMutation = {
  response: desktopRecorderApiPauseLocalRecordingMutation$data;
  variables: desktopRecorderApiPauseLocalRecordingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "meetingRecordingId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "meetingRecordingId",
        "variableName": "meetingRecordingId"
      }
    ],
    "concreteType": "ConfirmClientSideRecordingDidPause",
    "kind": "LinkedField",
    "name": "confirmClientSideRecordingDidPause",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "desktopRecorderApiPauseLocalRecordingMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "desktopRecorderApiPauseLocalRecordingMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c6c33c5d3be3eefd7b29ce72dd50f474",
    "id": null,
    "metadata": {},
    "name": "desktopRecorderApiPauseLocalRecordingMutation",
    "operationKind": "mutation",
    "text": "mutation desktopRecorderApiPauseLocalRecordingMutation(\n  $meetingRecordingId: ID!\n) {\n  confirmClientSideRecordingDidPause(meetingRecordingId: $meetingRecordingId) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "5455cd32376da752a9b89dd755edc201";

export default node;
